export enum WebsocketConnectionStatus {
	Connected,
	Disconnected,
	Reconnecting,
}
